export function getUrlSearchParams():URLSearchParams {
    let urlString = String(window.location.href).split('/');
    const urlSearch = new URLSearchParams(String(urlString[urlString.length-1]).split("?")[1]);
    return urlSearch
}